module.exports = __webpack_public_path__ + "static/img/img14.469160e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img14.png
// module id = 0tic
// module chunks = 1